import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { HomeComponent } from '../home/home.component'
import { InboxComponent } from '../inbox/inbox.component'
import { KnowHowComponent } from '../know-how/know-how.component'
import { NewsDetailsComponent } from '../news/components/news-details/news-details.component'
import { NotificationsDetailsComponent } from '../notifications/components/notification-details/notification-details-component'
import { HandoffLoginComponent } from '../security/components/handoff-login/handoff-login.component'
import { LoginComponent } from '../security/components/login/login.component'
import { AdminAuthGuard } from '../security/guards/admin-auth-guard.service'
import { StaffAuthGuard } from '../security/guards/staff-auth-guard.service'
import { PageNoPermissionComponent } from './errors/page-no-permission/page-no-permission.component'
import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component'
import { PageServerErrorComponent } from './errors/page-server-error/page-server-error.component'
import { FaqComponent } from './information/faq/faq.component'
import { HelpComponent } from './information/help/help.component'
import { ImprintComponent } from './information/imprint/imprint.component'
import { RootComponent } from './root/root.component'

const routes: Routes = [
    {
        path: '',
        component: RootComponent,
        children: [
            // protected routs
            {
                path: 'assignments',
                loadChildren: () => import('../assignments/assignment.module').then((m) => m.AssignmentModule),
                canActivate: [StaffAuthGuard],
            },

            {
                path: 'inbox',
                component: InboxComponent,
                canActivate: [StaffAuthGuard],
            },
            {
                path: 'notifications/:id',
                canActivate: [StaffAuthGuard],
                component: NotificationsDetailsComponent
            },
            {
                path: 'know-how',
                component: KnowHowComponent,
                canActivate: [StaffAuthGuard],
            },
            {
                path: 'profile',
                loadChildren: () => import('../profile/profile.module').then((m) => m.ProfileModule),
                canActivate: [StaffAuthGuard],
            },
            {
                path: 'news/:id',
                component: NewsDetailsComponent,
                canActivate: [StaffAuthGuard]
            },
            {
                path: 'admin',
                loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
                canActivate: [AdminAuthGuard],
            },

            // public routs
            { path: 'help', component: HelpComponent, },
            { path: 'faq', component: FaqComponent, },
            { path: 'imprint', component: ImprintComponent, },
            { path: 'notFound', component: PageNotFoundComponent },
            { path: 'error', component: PageServerErrorComponent },
            { path: 'forbidden', component: PageNoPermissionComponent },
            { path: 'login/handoff', component: HandoffLoginComponent },
            { path: 'login', component: LoginComponent },
            { path: 'home', component: HomeComponent, },
            { path: '**', redirectTo: 'home' },
        ],
    },
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MainRoutingModule { }
